// save ไว้ที่ D:\vuejs\project\tai_book\src\store\api\services\taimemberService.js
import Api from '@/services/Api'
import router from '@/router'
import store from '@/store'

export default {
    // memberpart2 Service ------------------------------------
    memberpart2List(credentials) {
        // console.log('credentials' + credentials)
        var param = '&pageno=' + credentials.pageNo
        param += '&rowperpage=' + credentials.rowsPerPage
        param += '&search=' + encodeURIComponent(credentials.search)
        if (credentials.sortBy) {
            param += '&sort=' + credentials.sortBy
            if (credentials.descending === 'true') {
                param += ' desc'
            }
        }
        return Api.httpServer().post(
            'taimember/default.asp?controller=memberpart2&action=list' + param,
            credentials
        )
    },
    memberpart2ItemByID(credentials) {
        // console.log('credentials', credentials)
        // var param = '&id=' + credentials.id
        // console.log('param', param)
        return Api.httpServer().post(
            'taimember/default.asp?controller=memberpart2&action=listbyparam',
            credentials
        )
    },
    memberpart2ListByParam(credentials) {
        return Api.httpServer().post(
            'taimember/default.asp?controller=memberpart2&action=listbyparam',
            credentials
        )
    },
    memberpart2Insert(credentials) {
        return Api.httpServer().post(
            'taimember/default.asp?controller=memberpart2&action=insert',
            credentials
        )
    },
    memberpart2Update(credentials) {
        return Api.httpServer().post(
            'taimember/default.asp?controller=memberpart2&action=update',
            credentials
        )
    },
    memberpart2Delete(credentials) {
        return Api.httpServer().post(
            'taimember/default.asp?controller=memberpart2&action=delete',
            credentials
        )
    },
  // quiz Service ------------------------------------
  quizList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'taimember/default.asp?controller=quiz&action=list' + param,
      credentials
    )
  },
  quizItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'taimember/default.asp?controller=quiz&action=listbyparam' ,
      credentials
    )
  },
  quizListByParam(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=quiz&action=listbyparam',
      credentials
    )
  },
  quizInsert(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=quiz&action=insert',
      credentials
    )
  },
  quizUpdate(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=quiz&action=update',
      credentials
    )
  },
  quizDelete(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=quiz&action=delete',
      credentials
    )
  },
  // vw_memberpart_all Service ------------------------------------
  vw_memberpart_allList(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'taimember/default.asp?controller=vw_memberpart_all&action=list' + param,
      credentials
    )
  },
  vw_memberpart_allItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'taimember/default.asp?controller=vw_memberpart_all&action=listbyparam' ,
      credentials
    )
  },
  vw_memberpart_allListByParam(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=vw_memberpart_all&action=listbyparam',
      credentials
    )
  },
  vw_memberpart_allInsert(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=vw_memberpart_all&action=insert',
      credentials
    )
  },
  vw_memberpart_allUpdate(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=vw_memberpart_all&action=update',
      credentials
    )
  },
  vw_memberpart_allDelete(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=vw_memberpart_all&action=delete',
      credentials
    )
  },
  // memberpart1 Service ------------------------------------
  memberpart1List(credentials) {
    // console.log('credentials' + credentials)
    var param = '&pageno=' + credentials.pageNo
    param += '&rowperpage=' + credentials.rowsPerPage
    param += '&search=' + encodeURIComponent(credentials.search)
    if (credentials.sortBy) {
      param += '&sort=' + credentials.sortBy
      if (credentials.descending === 'true') {
        param += ' desc'
      }
    }
    return Api.httpServer().post(
      'taimember/default.asp?controller=memberpart1&action=list' + param,
      credentials
    )
  },
  memberpart1ItemByID(credentials) {
    // console.log('credentials', credentials)
    // var param = '&id=' + credentials.id
    // console.log('param', param)
    return Api.httpServer().post(
      'taimember/default.asp?controller=memberpart1&action=listbyparam' ,
      credentials
    )
  },
  memberpart1ListByParam(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=memberpart1&action=listbyparam',
      credentials
    )
  },
  memberpart1Insert(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=memberpart1&action=insert',
      credentials
    )
  },
  memberpart1Update(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=memberpart1&action=update',
      credentials
    )
  },
  memberpart1Delete(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=memberpart1&action=delete',
      credentials
    )
  },
  sendMail(credentials) {
    return Api.httpServer().post(
      'taimember/default.asp?controller=member&action=Sendemail',
      credentials
    )
  },
    // memberall Service ------------------------------------
    memberallList(credentials) {
      // console.log('credentials' + credentials)
      var param = '&pageno=' + credentials.pageNo
      param += '&rowperpage=' + credentials.rowsPerPage
      param += '&search=' + encodeURIComponent(credentials.search)
      if (credentials.sortBy) {
        param += '&sort=' + credentials.sortBy
        if (credentials.descending === 'true') {
          param += ' desc'
        }
      }
      return Api.httpServer().post(
        'taimember/default.asp?controller=memberall&action=list' + param,
        credentials
      )
    },
    memberallItemByID(credentials) {
      // console.log('credentials', credentials)
      // var param = '&id=' + credentials.id
      // console.log('param', param)
      return Api.httpServer().post(
        'taimember/default.asp?controller=memberall&action=listbyparam' ,
        credentials
      )
    },
    memberallListByParam(credentials) {
      return Api.httpServer().post(
        'taimember/default.asp?controller=memberall&action=listbyparam',
        credentials
      )
    },
    memberallInsert(credentials) {
      return Api.httpServer().post(
        'taimember/default.asp?controller=memberall&action=insert',
        credentials
      )
    },
    memberallUpdate(credentials) {
      return Api.httpServer().post(
        'taimember/default.asp?controller=memberall&action=update',
        credentials
      )
    },
    memberallDelete(credentials) {
      return Api.httpServer().post(
        'taimember/default.asp?controller=memberall&action=delete',
        credentials
      )
    },
    //<services>
    errorHandel(res) {
        if (res.status === 401) {
            store.state.users.main = {}
            router.push('/signin')
        }
    }
}
